import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const helper_ani = {
	init: { opacity: 0, y: -3, marginTop: 0 },
	ani: {
		opacity: 1,
		y: 0,
		marginTop: 4,
		transition: { duration: 0.2 },
	},
	exit: {
		opacity: 0,
		y: -3,
		marginTop: 0,
		transition: { duration: 0.2 },
	},
};

export const helper_margin_ani = (_margin?: string) => {
	return {
		init: { opacity: 0, y: -3, margin: '0 0 0 0' },
		ani: {
			opacity: 1,
			y: 0,
			margin: _margin,
			transition: { duration: 0.2 },
		},
		exit: {
			opacity: 0,
			y: -3,
			margin: '0 0 0 0',
			transition: { duration: 0.2 },
		},
	};
};

export const InputWrapper = styled.div<{ _width?: string; _margin?: string }>`
	width: ${({ _width }) => _width};
	${({ _margin }) => _margin && `margin: ${_margin}`}
`;

export const InputBoxWrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const TextAreaBoxWrapper = styled(InputWrapper)`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
`;

export const InputBox = styled.input<{ is_error: boolean }>`
	width: 100%;
	min-width: 160px;
	height: 56px;
	padding: 0 16px;
	line-height: 56px;
	border-radius: 8px;
	outline: 0;
	display: block;

	border: ${({ theme }) => `1px solid ${theme.colors.gray.gray15}`};

	${({ theme }) => theme.typo.body.p_bold};

	color: ${(props) => props.theme.colors.gray.gray80_text};

	&::placeholder {
		color: ${({ theme }) => theme.colors.gray.gray20};
	}

	&:focus {
		border: ${(props) => `2px solid ${props.theme.colors.primary.primary50_key}`};
		${({ is_error, theme }) => is_error && `border: 2px solid ${theme.colors.system.red}`}
	}

	&:disabled {
		border: 0;
		background-color: ${({ theme }) => theme.colors.gray.gray15};
		color: ${({ theme }) => theme.colors.gray.gray30};
	}

	${({ is_error, theme }) => is_error && `border: 2px solid ${theme.colors.system.red}`}
`;

export const TextAreaBox = styled.textarea<{ is_error: boolean }>`
	width: 100%;
	min-width: 320px;
	height: 100%;
	min-height: 160px;
	padding: 16px;
	line-height: 56px;
	border-radius: 8px;
	outline: 0;
	display: block;
	resize: none;

	/* transition: height 0.2s; */

	border: ${({ theme }) => `1px solid ${theme.colors.gray.gray15}`};

	${({ theme }) => theme.typo.body.p_bold};

	color: ${(props) => props.theme.colors.gray.gray80_text};

	&::placeholder {
		color: ${({ theme }) => theme.colors.gray.gray20};
	}

	&:focus {
		border: ${(props) => `2px solid ${props.theme.colors.primary.primary50_key}`};
		${({ is_error, theme }) => is_error && `border: 2px solid ${theme.colors.system.red}`}
	}

	&:disabled {
		border: 0;
		background-color: ${({ theme }) => theme.colors.gray.gray15};
		color: ${({ theme }) => theme.colors.gray.gray30};
	}

	${({ is_error, theme }) => is_error && `border: 2px solid ${theme.colors.system.red}`}
`;

export const SearchInputBox = styled(InputBox)<{
	button_size?: number | false;
}>`
	padding-left: 52px;
	padding-right: ${({ button_size }) => button_size && `${button_size + 20}px`};
`;

export const PasswordInputBox = styled(InputBox).attrs<{ toggle_on: boolean }>(
	(props) => ({
		type: props.toggle_on ? 'text' : 'password',
	}),
)<{ toggle_on: boolean }>`
	padding-right: 52px;
`;

export const MoneyInputBox = styled(InputBox)`
	padding-left: 52px;
`;

export const ButtonInputBox = styled(InputBox)<{ button_size?: number }>`
	padding-right: ${({ button_size }) => button_size && `${button_size + 20}px`};
`;

export const LabelText = styled.label.attrs<{ input_id: string }>((props) => ({
	htmlFor: props.input_id,
}))<{ input_id: string; is_label: boolean }>`
	display: block;
	color: ${(props) => props.theme.colors.gray.gray80_text};
	${({ theme }) => theme.typo.body.span};
	${({ is_label }) => is_label && `margin-bottom: 4px`};
`;
export const HelperText = styled(motion.div)<{ is_error: 'true' | 'false' }>`
	color: ${(props) => props.theme.colors.gray.gray80_text};
	${({ theme }) => theme.typo.body.span};

	${(props) =>
		props.is_error === 'true' &&
		`color: ${props.theme.colors.system.red}; font-weight: ${props.theme.font.weight.bold};`}
`;

export const IconWrapper = styled.span`
	width: 24px;
	height: 24px;

	display: flex;
	justify-content: center;
	align-items: center;

	position: absolute;
	left: 14px;
	top: calc(50% - 12px);
`;

export const IconFocusWrapper = styled(IconWrapper)<{ is_focus?: boolean }>`
	left: initial;
	right: 12px;
	${({ is_focus }) =>
		is_focus
			? css`
					opacity: 1;
					cursor: pointer;
			  `
			: css`
					opacity: 0;
					pointer-events: none;
					cursor: default;
			  `};
`;

export const IconToggleWrapper = styled(IconWrapper)`
	left: initial;
	right: 12px;
`;

export const ButtonWrapper = styled(IconWrapper)`
	left: initial;
	right: 12px;
	top: calc(50% - 14px);
	right: 16px;
	width: min-content;
	height: 28px;
`;

export const MoneyIcon = styled(IconWrapper)`
	color: ${(props) => props.theme.colors.gray.gray60};
	${({ theme }) => theme.typo.body.p_bold};
`;
